import React, { useEffect } from "react";
import { AppState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { getPage } from "../store/page";
import { thunkUpdatePageAsync, updatePageByIdAsync } from "../store/page/action";
import GridLayout from "../aat/Grid/GridLayout";
import Shows from "./Shows";
import Helmet from "react-helmet";
import { CONTENT_TYPES, MetaComposition, SocialComposition } from "../typings/document-types";
import { thunkShowCustomCampaign, thunkShowVoucherPurchase } from "../store/basm/action";
import { absoluteURL } from "../util/UrlHelper";

interface PageProps extends RouteComponentProps<{ page?: string }> {
}

const UmbracoPage: React.FunctionComponent<StateProps & PageProps> = (props) => {
    const { match, location, updatePageAsync, updatePageByIdAsync } = props;

    useEffect(() => {
        // if (match.url === "/umbraco/preview/frame") {
        //     const search = location.search;
        //     const params = new URLSearchParams(search);
        //     const id = params.get("id");
        //     if (id) {
        //         updatePageByIdAsync(id);
        //         return; // STOP
        //     }
        // }
        if (props.page?._url !== match.url) {
            updatePageAsync(match.url);
        }

    }, [updatePageAsync, updatePageByIdAsync, match.url, location]);

    const renderMetaTags = (page: MetaComposition & SocialComposition | undefined = {}) => {
        if (page) {
            const { socialMedia, metaTitle, metaDescription, socialTitle, socialDescription } = page;

            const renderOpenGraphMedia = () => {
                if (socialMedia && socialMedia.length > 0) {
                    switch (socialMedia[0].mediaType) {
                        case "Video": {
                            return <meta property="og:video" content={absoluteURL(socialMedia[0].url)} />;
                        }
                        case "Image": {
                            return <meta property="og:image" content={absoluteURL(socialMedia[0].url)} />;
                        }
                    }
                }
            };

            return <Helmet>
                <html lang="da-DK" />
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />
                <meta property="og:title" content={socialTitle} />
                <meta property="og:description" content={socialDescription} />
                {renderOpenGraphMedia()}
            </Helmet>;
        }
    };

    const renderPage = (page: CONTENT_TYPES) => {
        if (page) {
            switch (page._contentType) {
                case "shows": {
                    return (
                        <main>
                            <Shows />
                        </main>
                    );
                }
                case "domainRoot":
                case "textpage":
                case "show": {
                    const { bodyText } = page;
                    return (
                        <main>
                            <GridLayout layout={bodyText} />
                        </main>
                    );
                }
                case "errorPage": {
                    return (
                        <Helmet>
                            <meta name="robots" content="noindex" />
                        </Helmet>
                    );
                }
            }
        }
        return null;
    };

    return (
        <>
            {renderMetaTags(props.page)}
            {renderPage(props.page as CONTENT_TYPES)}
        </>
    );
};

const mapStateToProps = (state: AppState) => {
    return {
        page: getPage(state.page),
    };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch) =>
    ({
        updatePageAsync: (pageName: string | undefined) => dispatch(thunkUpdatePageAsync(pageName)),
        updatePageByIdAsync: (pageId: string | number) => dispatch(updatePageByIdAsync(pageId)),
        showVoucherPurchase: () => dispatch(thunkShowVoucherPurchase()),
        showCustomCampaign: () => dispatch(thunkShowCustomCampaign())
    });

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(UmbracoPage);
